module.exports = __webpack_public_path__ + "static/media/handle.05320859.png";